import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import ReactTable from 'react-table';
import Select from 'react-select';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import makeAnimated from 'react-select/lib/animated';
import update from 'immutability-helper';
import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';
import Logged from '../Logged/Logged';
import { Permissions } from '../../Utils/Permissions';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import InputTag from '../../Components/Input-Tag/Input-Tag';
import './Billing.scss';

class BillingErrorList extends Component {

    constructor() {
        super();

        this.toggleFilters = this.toggleFilters.bind(this);
        this.getErrosFaturamento = this.getErrosFaturamento.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.permissaoFaturamento = this.permissaoFaturamento.bind(this);

        this._faturamentoFocusChange = this.handleFocusChange('faturamento').bind(this);
        this._faturamentoDatesChange = this.handleDatesChange('faturamento').bind(this);
        this._reprocessamentoFocusChange = this.handleFocusChange('reprocessamento').bind(this);
        this._reprocessamentoDatesChange = this.handleDatesChange('reprocessamento').bind(this);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.exibirMsgErroFaturamento = this.exibirMsgErroFaturamento.bind(this);
        this.toggleMensagemErroFaturamento = this.toggleMensagemErroFaturamento.bind(this);

        this.atualizaPedidos = this.atualizaPedidos.bind(this);

        this.toggleModalConfirmacao = this.toggleModalConfirmacao.bind(this);
        this.setAcao = this.setAcao.bind(this);
        this.fnAcaoModal = this.fnAcaoModal.bind(this);
        this.toggleModalSucesso = this.toggleModalSucesso.bind(this);

        this.habilitaBtnModal = this.habilitaBtnModal.bind(this);

        this.Configurations = new Configurations();
        this.logged = new Logged();

        this.tipoProcessamentoOptions = [
            { label: "Novo Pedido", value: 1 },
            { label: "Cancelamento", value: 2 },
            { label: "Alteração de titular", value: 3 },
            { label: "Alteração de itens", value: 4 },
        ];

        this.statusErroOptions = [
            { label: "Erro não ignorado", value: 0 },
            { label: "Erro ignorado", value: 1 },
        ];

        this.statusReprocessamentoOptions = [
            { label: "Não enviado para reprocessamento", value: 0 },
            { label: "Enviado para reprocessamento", value: 1 },
        ];

        this.state = {
            openFilters: true,
            filters: {
                faturamento: {
                    startDate: null,
                    endDate: null
                },
                reprocessamento: {
                    startDate: null,
                    endDate: null
                },
                listaTipoProcessamento: [],
                listaStatusReprocessamento: [],
                listaStatusErro: [],
            },
            acao: '',
            listaIdPedido: [],
            erroIgnorado: false,
            dtReprocessamentoNull: false,
            hasError: false,
            errorMessage: '',
            modalErroFaturamento: false,
            mensagemErroFaturamento: '',
            idFaturamentoErro: '',
            isLoadingAcaoModal: false,
            modalSucesso: false,
            buscaMensagem: '',
            loading: true
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this.columns = [
            {
                Header: 'id',
                accessor: 'idFaturamentoErro',
                className: 'text-center pointer',
                width: 50
            },
            {
                Header: 'Pedido',
                className: 'pointer text-center',
                accessor: 'idPedido',
                width: 60,
            },
            {
                Header: 'Processamento',
                className: 'pointer text-center',
                accessor: 'nomeProcessamento',
                width: 130,
            },
            {
                Header: 'Erro',
                accessor: 'mensagemRetorno',
                className: 'text-center pointer',
                width: 90,
                Cell: row => (
                    <span>{row.value !== undefined && row.value !== null ? <button onClick={() => this.exibirMsgErroFaturamento(row.value, row.original.idFaturamentoErro)} className="btn btn-sm btn-outline-primary">mensagem</button> : 'Indisponível'}</span>
                )
            },
            {
                Header: "Dt. Criação",
                accessor: 'dtCriacao',
                className: 'pointer text-center',
                width: 120,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: 'Dt. Envio Reprocess.',
                accessor: 'dtEnvioReprocessamento',
                className: 'pointer text-center',
                width: 140,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: '',
                className: "text-center",
                width: 200,
                Cell: (row) => {
                    const _ignorado = row.original.ignorar,
                        _dtEnvioReproc = moment(row.original.dtEnvioReprocessamento).isValid();
                    return (
                        <>
                            {row.original.reprocessarLoading ? (
                                <div className="spinner-border spinner-border-sm text-primary" role="status" />
                            ) : (
                                    <button disabled={row.original.ignorarLoading} onClick={() => this.setAcao(row.original.idFaturamentoErro, "reprocessamento")} className={`btn btn-sm btn-outline-info ${(_ignorado || _dtEnvioReproc) ? 'd-none' : ''}`}>enviar p/ reprocessamento</button>
                                )
                            }
                        </>
                    )
                }
            },
            {
                Header: 'Status',
                className: "text-center",
                width: 80,
                Cell: (row) => {
                    const _ignorado = row.original.ignorar,
                        _dtEnvioReproc = moment(row.original.dtEnvioReprocessamento).isValid();
                    return (_ignorado ? <span className="badge badge-danger">ignorado</span> :
                        _dtEnvioReproc ? <span className="badge badge-info">reprocess.</span> : <></>)
                }
            },
            {
                Header: '',
                className: "text-center",
                width: 150,
                Cell: (row) => {
                    const _ignorado = row.original.ignorar,
                        _dtEnvioReproc = moment(row.original.dtEnvioReprocessamento).isValid(),
                        _btnColor = _ignorado ? 'success' : 'danger',
                        _btnLabel = _ignorado ? 'reconsiderar erro' : 'ignorar erro',
                        _btnAcao = _ignorado ? 'reconsiderar' : 'ignorar'
                    return (
                        <>
                            {row.original.ignorarLoading ? (
                                <div className="spinner-border spinner-border-sm text-primary" role="status" />
                            ) : (
                                    <button disabled={row.original.reprocessarLoading} onClick={() => this.setAcao(row.original.idFaturamentoErro, _btnAcao)} className={`btn btn-sm btn-outline-${_btnColor} ${(_dtEnvioReproc) ? 'd-none' : ''}`}>{_btnLabel}</button>
                                )
                            }
                        </>
                    )
                }
            }
        ];

    }

    componentDidMount() {
    }

    permissaoFaturamento(_user) {
        const _arrPerm = _user.permissions,
            _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat(),
            _permAdmin = ["admin"].some(r => _paginas.indexOf(r) >= 0),
            // _permFaturamento = ["faturamento"].some(r => _paginas.indexOf(r) >= 0);
            _permFaturamento = ["faturamento"].some(r => _paginas.indexOf(r) >= 0);
        return _permAdmin || _permFaturamento;
    }

    handleSelectChange(e, o) {
        const _name = o.name;
        const _isMulti = !!o.option;

        if (_isMulti) {
            let _listaFiltro = this.state.filters[_name];
            switch (o.action) {
                case "remove-value":
                    const _index = _listaFiltro.findIndex(item => item === o.removedValue);
                    _listaFiltro.splice(_index, 1);
                    break;
                case "clear":
                    const _filters = this.state.filters;
                    _filters[_name] = [];
                    this.setState({
                        filters: _filters
                    });
                    return o;
                default:
                    _listaFiltro.push(o.option)
                    break;
            }
            const _filters = update(this.state.filters, { $set: { [_name]: o.option } });
            this.setState({ _filters });
        } else {
            let _valorFiltro;
            switch (o.action) {
                case "clear": _valorFiltro = []; break;
                case "select-option": _valorFiltro = [{ value: e.value, label: e.label }]; break;
                default: _valorFiltro = []; break;
            }
            this.setState({ filters: update(this.state.filters, { [_name]: { $set: _valorFiltro } }) });
        }

        return o;
    }

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    getErrosFaturamento(o) {
        this.setState({ loading: true });

        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
            if (!(o.page + 1)) {
                o.page = 1;
                _params.push(`pagina=${o.page}`);
            }
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        if (this.state.filters.listaTipoProcessamento.length > 0) {
            _params.push(`listaIdTipoProcessamento=${this.state.filters.listaTipoProcessamento.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.listaStatusReprocessamento.length > 0) {
            _params.push(`filtroEnviadoReprocessamento=${this.state.filters.listaStatusReprocessamento[0].value}`);
        }

        if (this.state.filters.listaStatusErro.length > 0) {
            _params.push(`filtroIgnorado=${this.state.filters.listaStatusErro[0].value}`);
        }

        if (this.state.listaIdPedido.length > 0) {
            _params.push(`listaIdPedido=${this.state.listaIdPedido.join(',')}`);
        }

        if (moment(this.state.filters.faturamento.startDate).isValid()) {
            _params.push(`dtCriacaoInicio=${moment(this.state.filters.faturamento.startDate).format("DD/MM/YYYY")}`);
        }
        if (moment(this.state.filters.faturamento.endDate).isValid()) {
            _params.push(`dtCriacaoFim=${moment(this.state.filters.faturamento.endDate).format("DD/MM/YYYY")}`);
        }

        if (moment(this.state.filters.reprocessamento.startDate).isValid()) {
            _params.push(`dtEnvioReprocessamentoInicio=${moment(this.state.filters.reprocessamento.startDate).format("DD/MM/YYYY")}`);
        }
        if (moment(this.state.filters.reprocessamento.endDate).isValid()) {
            _params.push(`dtEnvioReprocessamentoFim=${moment(this.state.filters.reprocessamento.endDate).format("DD/MM/YYYY")}`);
        }

        if (this.state.buscaMensagem.trim() !== '') {
            _params.push(`mensagemRetorno=${this.state.buscaMensagem}`);
        }

        const _faturamentos = axios.get(this.Configurations.apiBasePath + `/faturamentos/erros?${_params.join('&')}`);

        const _parametros = _params.join('&');

        _faturamentos.then(response => {
            this.setState({
                listaFaturamentoErro: response.data.listaFaturamentoErro,
                pages: response.data.paginacao.totalPaginas,
                parametros: _parametros
            });
        }).catch(err => {
            if (err.response.status === 404) this.setState({
                listaFaturamentoErro: [],
                pages: 1,
                parametros: _parametros
            })
        }).finally(() => this.setState({ loading: false }));
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.startDate = startDate;
            dates.endDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    refreshTable(o) {
        this.getErrosFaturamento(o);
    }

    _outsideRange(day) {
        return day.format() > moment().format();
    }

    filterSearch(e) {
        e.preventDefault();
        this.getErrosFaturamento({});
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    exibirMsgErroFaturamento(msg, idFaturamentoErro) {
        this.setState({
            mensagemErroFaturamento: msg,
            idFaturamentoErro: idFaturamentoErro
        }, () => this.toggleMensagemErroFaturamento())
    }

    toggleMensagemErroFaturamento() {
        this.setState({ modalErroFaturamento: !this.state.modalErroFaturamento }, () => {
            if (!this.state.modalErroFaturamento) this.setState({ mensagemErroFaturamento: '', idFaturamentoErro: '' })
        })
    }

    atualizaPedidos(_lista) {
        this.setState({ listaIdPedido: _lista })
    }

    toggleModalConfirmacao() {
        this.setState({ modalConfirmacao: !this.state.modalConfirmacao })
    }

    setAcao(idFaturamentoErro, acao) {
        this.setState({
            idFaturamentoErro: idFaturamentoErro,
            acaoModal: acao,
            modalSucesso: false
        }, () => this.toggleModalConfirmacao())
    }

    fnAcaoModal() {
        this.setState({ isLoadingAcaoModal: true, modalErroFaturamento: false });
        let _api, _method;
        switch (this.state.acaoModal) {
            case "ignorar":
                _api = "ignorar";
                _method = "put";
                break;
            case "reconsiderar":
                _api = "ignorar";
                _method = "put";
                break;
            case "reprocessamento":
                _api = "reprocessar";
                _method = "post";
                break;
            default:
                break;
        }

        const _index = this.state.listaFaturamentoErro.findIndex(item => item.idFaturamentoErro === this.state.idFaturamentoErro);
        this.setState({ listaFaturamentoErro: update(this.state.listaFaturamentoErro, { [_index]: { [`${_api}Loading`]: { $set: true } } }) })
        axios[_method](this.Configurations.apiBasePath + `/faturamentos/erros/${this.state.idFaturamentoErro}/${_api}`)
            .then(response => {
                this.getErrosFaturamento({});
                this.setState({ modalSucesso: true })
            })
            .catch(this.handleError)
            .finally(() => {
                this.setState({
                    listaFaturamentoErro: update(this.state.listaFaturamentoErro, { [_index]: { [`${_api}Loading`]: { $set: true } } }),
                    isLoadingAcaoModal: false
                })
            });
    }

    toggleModalSucesso() {
        this.setState({ modalSucesso: !this.state.modalSucesso })
    }

    handleOnChange(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    habilitaBtnModal(idFaturamentoErro) {
        if (this.state.idFaturamentoErro === '') return {}
        const _item = this.state.listaFaturamentoErro.filter(item => item.idFaturamentoErro === idFaturamentoErro)[0],
            _dtEnvioReproc = _item ? moment(_item.dtEnvioReprocessamento).isValid() : false,
            _ignorado = _item ? _item.ignorar : false;

        return {
            btnIgnorar: !_dtEnvioReproc && !_ignorado,
            btnReconsiderar: !_dtEnvioReproc && !!_ignorado,
            btnEnvio: !_dtEnvioReproc && !_ignorado
        }
    }

    render() {
        return (
            <div className="faturamento">
                <div className="row">
                    <div className="col-9">
                        <h2 className="title-1">Faturamento - Lista de Erros</h2>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header p-2" id="headingOne">
                                <div className="col-12">
                                    <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleFilters}>
                                        <i className={`fa mr-2 ${this.state.openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                        Filtros
                                    </button>
                                </div>
                            </div>
                            <div className={`card-body ${!this.state.openFilters && "collapse"}`} id="boxFilters">
                                {this.state.loading ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                        <form onSubmit={this.filterSearch} noValidate>
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="dpBillingStartDate">Criação do Faturamento</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.faturamento.startDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpBillingStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.faturamento.endDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpBillingEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._faturamentoDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.faturamento.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._faturamentoFocusChange}
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="dpReprocessStartDate">Reprocessamento do Faturamento</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.reprocessamento.startDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpReprocessStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.reprocessamento.endDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpReprocessEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._reprocessamentoDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.reprocessamento.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._reprocessamentoFocusChange}
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlTipoProcessamento">Tipo de processamento</label>
                                                        <Select
                                                            id="ddlTipoProcessamento"
                                                            placeholder="Selecione um ou mais tipos"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaTipoProcessamento}
                                                            isMulti
                                                            name="listaTipoProcessamento"
                                                            onChange={this.handleSelectChange}
                                                            options={this.tipoProcessamentoOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusReprocessamento">Envio p/ reprocessamento</label>
                                                        <Select
                                                            id="ddlStatusReprocessamento"
                                                            placeholder="Selecione um status"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaStatusReprocessamento[0]}
                                                            name="listaStatusReprocessamento"
                                                            onChange={this.handleSelectChange}
                                                            options={this.statusReprocessamentoOptions}
                                                            isClearable
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusErro">Status Erro</label>
                                                        <Select
                                                            id="ddlStatusErro"
                                                            placeholder="Selecione um status"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaStatusErro[0]}
                                                            name="listaStatusErro"
                                                            onChange={this.handleSelectChange}
                                                            options={this.statusErroOptions}
                                                            isClearable
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4 tags-pedido">
                                                    <label>Busca por pedido</label>
                                                    <InputTag atualizaTags={this.atualizaPedidos} tags={this.state.listaIdPedido} textInput={true} />
                                                    <small>Insira o nº do(s) pedido(s) e pressione "Enter" ou "Tab".</small>
                                                </div>
                                                <div className="col-8 py-3">
                                                    <label>Busca por mensagem de erro</label>
                                                    <textarea name="buscaMensagem" rows="3" maxLength="200" className="w-100 form-control" onChange={this.handleOnChange} value={this.state.buscaMensagem} />
                                                    <small>Máx: 200 caracteres.</small>
                                                </div>
                                                {/* <div className="offset-2 col-2 text-right align-items-center d-flex justify-content-end"> */}
                                                <div className="col-12 text-right">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <button className="btn btn-primary">Buscar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                    )}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.listaFaturamentoErro}
                                    columns={this.columns}
                                    onFetchData={this.refreshTable}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight table-atendimento"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próxima'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum erro de faturamento encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                />

                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.modalConfirmacao} toggle={this.toggleModalConfirmacao}>
                    <ModalHeader toggle={this.toggleModalConfirmacao}>Faturamento - id: {this.state.idFaturamentoErro}</ModalHeader>
                    <ModalBody>
                        {this.state.modalSucesso ? (
                            <>
                                <p className="m-0">Operação realizada com sucesso.</p>
                            </>
                        ) : (
                                <>
                                    {this.state.acaoModal === "reprocessamento" ? (
                                        <p className="m-0">Deseja confirmar o envio do item para <strong>reprocessamento?</strong></p>
                                    ) : (
                                            <>
                                                {this.state.acaoModal === "ignorar" ? (
                                                    <p className="m-0">Deseja confirmar a ação de <strong>ignorar o erro</strong> do item de faturamento?</p>
                                                ) : (
                                                        <p className="m-0">Deseja confirmar a ação de <strong>reconsiderar o erro</strong> do item de faturamento {this.state.idFaturamentoErro}?</p>
                                                    )}
                                            </>
                                        )}
                                </>
                            )}
                    </ModalBody>
                    <ModalFooter>
                        {this.state.modalSucesso ? (
                            <Button onClick={this.toggleModalConfirmacao} color="success">ok</Button>
                        ) : (
                                <>
                                    {this.state.isLoadingAcaoModal ? (
                                        <div className="row no-gutters w-100 text-right">
                                            <div className="col-12">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                            <>
                                                <Button onClick={this.fnAcaoModal} color={`${this.state.acaoModal === "ignorar" ? 'danger' : 'success'}`}>sim</Button>
                                                <Button onClick={this.toggleModalConfirmacao} color="secondary">voltar</Button>
                                            </>
                                        )}
                                </>
                            )}
                    </ModalFooter>
                </Modal >

                {/* {!this.state.loading && ( */}
                <Modal isOpen={this.state.modalErroFaturamento} toggle={this.toggleMensagemErroFaturamento} size="lg">
                    <ModalHeader toggle={this.toggleMensagemErroFaturamento}>Erro de Faturamento - id: {this.state.idFaturamentoErro}</ModalHeader>
                    <ModalBody>
                        <textarea rows={10} className="w-100">{this.state.mensagemErroFaturamento}</textarea>
                    </ModalBody>
                    <ModalFooter>
                        {this.habilitaBtnModal(this.state.idFaturamentoErro).btnEnvio && (
                            <Button onClick={() => this.setAcao(this.state.idFaturamentoErro, "reprocessamento")} color="info">enviar para reprocessamento</Button>
                        )}
                        {this.habilitaBtnModal(this.state.idFaturamentoErro).btnIgnorar && (
                            <Button onClick={() => this.setAcao(this.state.idFaturamentoErro, "ignorar")} color="danger">ignorar erro</Button>
                        )}
                        {this.habilitaBtnModal(this.state.idFaturamentoErro).btnReconsiderar && (
                            <Button onClick={() => this.setAcao(this.state.idFaturamentoErro, "reconsiderar")} color="success">reconsiderar erro</Button>
                        )}
                        <Button onClick={this.toggleMensagemErroFaturamento} color="secondary">voltar</Button>
                    </ModalFooter>
                </Modal>
                {/* )} */}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={false}
                />
            </div >
        )
    }
}

export default BillingErrorList;